<!-- 组件模板内容 -->
<template>
  <div>
    <TravelInfo ref="TravelInfo"></TravelInfo>
  </div>
</template>

<script>
import TravelInfo from "./component/TravelInfo.vue";
export default {
  name: "TravelInfoComponent",
  components: {TravelInfo},
  // 组件的data属性
  data() {
    return {
      isJd:1
    };
  },

  // 组件的方法
  methods: {
    openTravelInfo(id){
      this.$refs.TravelInfo.getTravelInfo(id)
    }
  },
  // 在created钩子中执行的操作
  created() {},
};
</script>

<!-- 组件的样式 -->
<style scoped>
</style>
